import * as ActionTypes from '../constants/ActionTypes';
import { ActionCreator } from '../utils/flux';

/**
 * @class ExternalActions
 * @extends ActionCreator
 */
export default class ExternalActions extends ActionCreator {
    /**
     * @param {int} availabilityTimeFilter
     */
    changeAvailabilityTimeFilter(availabilityTimeFilter) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_AVAILABILITY_TIME_FILTER,
            availabilityTimeFilter,
        });
    }

    /**
     * @param {int} insuranceCarrier
     * @param {int} insurancePlan
     */
    changeInsurance(insuranceCarrier, insurancePlan) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_INSURANCE,
            insuranceCarrier,
            insurancePlan,
        });
    }

    /**
     * @param {String} procedureId
     */
    changeProcedure(procedureId) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_PROCEDURE,
            procedureId,
        });
    }

    /**
     * @param isExisting
     */
    changeIsExistingPatient(isExisting) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_IS_EXISTING_PATIENT,
            isExisting,
        });
    }

    changeDoctorLocationIds(doctorLocationIds) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_DOCTOR_LOCATION_IDS,
            doctorLocationIds,
        });
    }
}
